import { render, staticRenderFns } from "./QuizBanner.vue?vue&type=template&id=37627d31&scoped=true&"
import script from "./QuizBanner.vue?vue&type=script&lang=js&"
export * from "./QuizBanner.vue?vue&type=script&lang=js&"
import style0 from "./QuizBanner.vue?vue&type=style&index=0&id=37627d31&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37627d31",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37627d31')) {
      api.createRecord('37627d31', component.options)
    } else {
      api.reload('37627d31', component.options)
    }
    module.hot.accept("./QuizBanner.vue?vue&type=template&id=37627d31&scoped=true&", function () {
      api.rerender('37627d31', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staff-engagement/components/QuizBanner.vue"
export default component.exports